<template>
  <sui-page>
    <!-- Page Header -->
    <sui-page-header title="[Samples] Tree Grid" />

    <!-- Page Contents -->
    <sui-page-contents>
      <!-- Tree Grid [01] -->
      <div class="comm_title_wrap">
        <h5>(singleRow) Simple Tree Grid</h5>
      </div>
      <sui-tree-grid
        ref="treeGrid01"
        :columns="treeGridColumns01"
        :autoheight="true"
        :dataset="'dataset0'"
        :selectionMode="'singleRow'"
      />

      <!-- Tree Grid [02] -->
      <div class="comm_title_wrap">
        <h5>(singleRow) Tree Grid - Hierarchical Column Checkboxes</h5>
      </div>
      <div class="comm_gridTop_wrap">
        <div class="btn_wrapL">
           <button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickAddRow('treeGrid02')"
          >
            행추가
          </button>
          <button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickDeleteCheckedRows('treeGrid02')"
          >
            행삭제
          </button>
          <button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickResetData('treeGrid02')"
          >
            초기화
          </button>
         
          <button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickToChecksRows('treeGrid02')"
          >
            Checked
          </button>
        </div>
      </div>
      <sui-tree-grid
        ref="treeGrid02"
        :columns="treeGridColumns01"
        :height="300"
        :editable="true"
        :dataset="'dataset0'"
        :selectionMode="'singleRow'"
        :checkboxes="true"
        :hierarchicalCheckboxes="true"
      />
    </sui-page-contents>
  </sui-page>
</template>

<script>
let tempNumber = 6;

export default {
  name: 'CompGuideTreeGrid',
  data() {
    return {
      // TreeGrid 컬럼 정의
      treeGridColumns01: [
        { text: '업무명', datafield: 'jobTitle' },
        { text: 'rowId', datafield: 'dataset-row-id', width: 60 },
        { text: '업무코드', datafield: 'jobCode', cellsrenderer: this.cellsrenderer },
        { text: '레벨', datafield: 'jobLevel' },
        { text: '정렬순서', datafield: 'jobPriority' },
      ],

      // TreeGrid 데이타셋1의 로컬데이터
      stateData: [
        {
          id: 'DATA_001',
          parent: 'DATA_002',
          jobTitle: 'spider man',
          jobCode: '코메디',
          jobPriority: '3',
          jobLevel: '3',
          selectedRow: 'N',
        },
        {
          id: 'DATA_002',
          parent: null,
          jobTitle: '공통',
          jobCode: '판타지',
          jobPriority: '2',
          jobLevel: '1',
          selectedRow: 'Y',
        },
        {
          id: 'DATA_003',
          parent: 'DATA_002',
          jobTitle: 'toy story 4',
          jobCode: '코메디',
          jobPriority: '1',
          jobLevel: '0',
          selectedRow: 'N',
        },
        {
          id: 'DATA_004',
          parent: 'DATA_002',
          jobTitle: 'John Wick',
          jobCode: '스릴러',
          jobPriority: '8',
          jobLevel: '1000000000000000000000000',
          selectedRow: 'N',
        },
        {
          id: 'DATA_005',
          parent: null,
          jobTitle: 'FLMS',
          jobCode: '판타지',
          jobPriority: '9',
          jobLevel: '128',
          selectedRow: 'Y',
        },
      ],
    };
  },
  mounted() {
    console.log('[Sample-TreeGrid] mounted() was called.');
    this.dataset0.$on(this.dataset0.EVENTS.SELECTION_CHANGED, this.selectionChanged);
  },
  beforeDestroy() {
    console.log('[Sample-TreeGrid] beforeDestroy() was called.');
    this.dataset0.$off(this.dataset0.EVENTS.SELECTION_CHANGED, this.selectionChanged);
  },
  methods: {
    cellsrenderer(row, columnfield, value, defaulthtml, columnproperties) {
      // NOTE: html 으로 리턴.
      // https://www.jqwidgets.com/jquery-widgets-documentation/documentation/jqxgrid/jquery-grid-cellsrendering.htm
      if (value === '판타지') {
        return `<span title=${value}>**${value}**</span>`;
      }
      return `<span>${value}</span>`;
    },

    selectionChanged(e) {
      console.log('[Sample-TreeGrid] selectionChanged', e);
    },

    onClickResetData(treeGridId) {
      console.log(`[SampleTreeGrid] onClickResetData(): treeGridId = ${treeGridId}`);
      this.dataset0.reset();
    },

    onClickAddRow(treeGridId) {
      console.log(`[SampleTreeGrid] onClickAddRow(): treeGridId = ${treeGridId}`);
      const id = `DATA_00${tempNumber}`;
      const sampleRowData = {
        id,
        parent: 'DATA_005',
        jobTitle: '이클립스',
        jobCode: '판타지',
        jobPriority: '9',
        jobLevel: '128',
        selectedRow: 'Y',
      };

      // ADD
      this.dataset0.addRows([sampleRowData]);

      tempNumber += 1;
    },

    onClickDeleteCheckedRows(treeGridId) {
      const rowIds = [];
      const checkedRows = this.$refs[treeGridId].getJqxTreeGrid().getCheckedRows();
      checkedRows.forEach(row => {
        rowIds.push(row['dataset-row-id']);
      });
      console.log(`[SampleTreeGrid] onClickDeleteRow(): rowIds = ${rowIds}`);

      // DELETE
      this.dataset0.deleteRowsByRowId(rowIds);
    },

    onClickToChecksRows(treeGridId) {
      const checkedRows = [{"jobTitle":"공통","jobCode":"판타지","jobLevel":"1","jobPriority":"2","selectedRow":"Y","id":"DATA_002","parent":null,"dataset-row-id":"2","uid":"2","records":[{"jobTitle":"spider man","jobCode":"코메디","jobLevel":"3","jobPriority":"3","selectedRow":"N","id":"DATA_001","parent":"DATA_002","dataset-row-id":"1","uid":"1","level":1,"leaf":true,"_visible":true,"checked":true},{"jobTitle":"toy story 4","jobCode":"코메디","jobLevel":"0","jobPriority":"1","selectedRow":"N","id":"DATA_003","parent":"DATA_002","dataset-row-id":"3","uid":"3","level":1,"leaf":true,"_visible":true,"checked":true},{"jobTitle":"John Wick","jobCode":"스릴러","jobLevel":"1000000000000000000000000","jobPriority":"8","selectedRow":"N","id":"DATA_004","parent":"DATA_002","dataset-row-id":"4","uid":"4","level":1,"leaf":true,"_visible":true,"checked":true}],"level":0,"_visible":true,"expanded":true,"checked":true},{"jobTitle":"spider man","jobCode":"코메디","jobLevel":"3","jobPriority":"3","selectedRow":"N","id":"DATA_001","parent":"DATA_002","dataset-row-id":"1","uid":"1","level":1,"leaf":true,"_visible":true,"checked":true},{"jobTitle":"toy story 4","jobCode":"코메디","jobLevel":"0","jobPriority":"1","selectedRow":"N","id":"DATA_003","parent":"DATA_002","dataset-row-id":"3","uid":"3","level":1,"leaf":true,"_visible":true,"checked":true},{"jobTitle":"John Wick","jobCode":"스릴러","jobLevel":"1000000000000000000000000","jobPriority":"8","selectedRow":"N","id":"DATA_004","parent":"DATA_002","dataset-row-id":"4","uid":"4","level":1,"leaf":true,"_visible":true,"checked":true}]; // eslint-disable-line
      console.log(JSON.stringify(checkedRows));
      checkedRows.forEach(row => {
        this.$refs[treeGridId].getJqxTreeGrid().checkRow(row.uid);
      });
    },
  },
  datasets: [
    // TreeGrid 데이타셋1
    {
      id: 'dataset0',
      componentType: 'tree-grid',
      data: 'stateData',
      hierarchy: {
        keyDataField: {
          name: 'id',
        },
        parentDataField: {
          name: 'parent',
        },
      },
      datafields: [
        {
          name: 'jobTitle',
          type: 'string',
          map: 'jobTitle',
        },
        {
          name: 'jobCode',
          type: 'string',
          map: 'jobCode',
        },
        {
          name: 'jobLevel',
          type: 'string',
          map: 'jobLevel',
        },
        {
          name: 'jobPriority',
          type: 'string',
          map: 'jobPriority',
        },
        {
          name: 'state',
          type: 'string',
          map: 'state',
        },
        {
          name: 'selectedRow',
          type: 'string',
          map: 'selectedRow',
          rowSelect: ['Y', 'N'],
        },
        {
          name: 'id',
          type: 'string',
          map: 'id',
        },
        {
          name: 'parent',
          type: 'string',
          map: 'parent',
        },
        {
          name: 'dataset-row-id',
          type: 'string',
          map: 'dataset-row-id',
        },
      ],
    },

  ],
};
</script>

<style scoped>

</style>
